import * as React from 'react';
import { SurfaceContext } from '../../../types/contexts';
import { createSurfaceContextProvider } from '../../common/surface-context-provider';

export const UserSettingsPanelContext = React.createContext<SurfaceContext>({ isOpen: false });
export const UserSettingsPanelContextProvider = createSurfaceContextProvider(UserSettingsPanelContext);
